var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliveryBike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8527 1.77662C14.8527 0.993192 14.1024 0.352203 13.1855 0.352203H10.6847V1.77662H13.1855V3.66398L10.2846 6.76209H7.3503V3.20104H4.01591C2.17366 3.20104 0.681519 4.47589 0.681519 6.04988V8.18651H2.34871C2.34871 9.36877 3.46573 10.3231 4.84951 10.3231C6.23328 10.3231 7.3503 9.36877 7.3503 8.18651H11.0848L14.8527 4.16252V1.77662ZM4.84951 8.89872C4.39103 8.89872 4.01591 8.57822 4.01591 8.18651H5.6831C5.6831 8.57822 5.30798 8.89872 4.84951 8.89872Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35031 1.06438H3.18231V2.48879H7.35031V1.06438Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8527 6.04985C13.4689 6.04985 12.3519 7.00421 12.3519 8.18647C12.3519 9.36873 13.4689 10.3231 14.8527 10.3231C16.2364 10.3231 17.3535 9.36873 17.3535 8.18647C17.3535 7.00421 16.2364 6.04985 14.8527 6.04985ZM14.8527 8.89867C14.3942 8.89867 14.0191 8.57818 14.0191 8.18647C14.0191 7.79475 14.3942 7.47426 14.8527 7.47426C15.3111 7.47426 15.6863 7.79475 15.6863 8.18647C15.6863 8.57818 15.3111 8.89867 14.8527 8.89867Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryBike);
export default __webpack_public_path__ + "static/media/delivery-bike.3e79dc7a0290cc30debefce65be85ab9.svg";
export { ForwardRef as ReactComponent };